import type { ActionEvent, ClientDiagnostics, DemoSession, FaceResult, FlowType } from './types';
import { responseError } from './errorMessages';

export interface MemberProfile { member: { memberId: string; name: string; maskedId: string }; csrfToken: string; expiresAt: string; enrolled: boolean; nextStep: FlowType; batchId: string | null }
export interface Agreement { title: string; html: string; markdown?: string | null; version: string; updatedAt: string }
export interface PersonalRecord { sessionId: string; step: FlowType; state: string; reason: string; createdAt: string; agreementVersion: string }
export class ApiError extends Error { constructor(message: string, readonly status: number) { super(message); } }

/** 个人凭据只由 HttpOnly Cookie 发送，前端只持有防跨站请求的 CSRF 值。 */
export class VerificationApi {
  csrfToken = '';
  async request<T>(path: string, init: RequestInit = {}): Promise<T> {
    const response = await fetch(`/api/verification${path}`, { ...init, credentials: 'same-origin', cache: 'no-store', headers: { 'X-CSRF-Token': this.csrfToken, ...init.headers } });
    if (!response.ok) throw new ApiError(await responseError(response), response.status);
    return response.json() as Promise<T>;
  }
  async profile(): Promise<MemberProfile> {
    const profile = await this.request<MemberProfile>('/auth/me');
    this.csrfToken = profile.csrfToken;
    return profile;
  }
  async login(name: string, idLastSix: string, rememberMe: boolean): Promise<MemberProfile> {
    const profile = await this.request<MemberProfile>('/auth/login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name, idLastSix, rememberMe }) });
    this.csrfToken = profile.csrfToken;
    return profile;
  }
  batch(): Promise<MemberProfile> { return this.request('/verificationBatch', { method: 'POST' }); }
  agreement(step: FlowType): Promise<Agreement> { return this.request(`/agreement/${step}`); }
  createSession(batchId: string, flowType: FlowType, agreementVersion: string): Promise<DemoSession> {
    return this.request('/liveness/session', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ batchId, flowType, agreementVersion, accepted: true }) });
  }
  uploadFace(operation: 'enroll' | 'verify', sessionId: string, actionEvents: ActionEvent[], image: Blob, diagnostics: ClientDiagnostics): Promise<FaceResult> {
    const form = new FormData();
    form.set('sessionId', sessionId); form.set('actionEvents', JSON.stringify(actionEvents));
    form.set('diagnostics', JSON.stringify(diagnostics)); form.set('image', image, 'face.jpg');
    return this.request(`/face/${operation}`, { method: 'POST', body: form });
  }
}
